import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import isNull from 'lodash/isNull'

import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'
import { RawExpando } from 'discada/dist/Expando'
import { getHasMdrive } from 'selectors/appStatusSelectors'

import { addToPageState, removeFromPageState } from 'actions/pageStateActions'

import {
  getAllVehilceIds,
  getSelectedFilters,
  isLoading,
  inventoryHasLeases,
  inventoryHasLoans,
  getFilteredInventoryCount,
} from 'selectors/inventorySelectors'

import { getDefaultSort } from 'selectors/appStatusSelectors'

import {
  getVehicleIds,
  getSortBy,
  MDRIVE_SORT_BYS,
  SORT_BYS,
  PAYMENT_FILTER_OPTIONS,
} from 'selectors/inventorySelectors'

import { getParamValue, getQueryValue } from 'selectors/pageStateSelectors'

import { clearFilters, setSortBy } from 'actions/inventoryActions'
import DropDownFilter from 'components/widgets/DropDownFilter'
import { moneyShort, numShort, num } from 'utils'
import { WILDCARD } from 'selectors/quoteSelectors'
import StoryFilter from 'pages/inventory/InventoryStory'

import './InventoryControls.scss'
import { getIsLoggedIn } from 'selectors/authSelectors'

export class DashboardControls extends React.Component {
  render() {
    let {
        addToPageState,
        removeFromPageState,
        className,
        clearFilters,
        trueResultsCount,
        isLoading,
        sortBy,
        hasMdrive,
        selectedFiltersCount,
        noSqueeze,
      } = this.props,
      itemMapper = prefix => (item, i) => (
        <div key={prefix + i} className="inventory-control-item">
          {item}
        </div>
      )

    let heroRow = [
        hasMdrive && (
          <DropDownFilter
            allowWilcard={hasMdrive}
            namespace="q"
            size="large"
            filter="payment"
            label={v =>
              `${
                v
                  ? `${v
                      .toString()
                      .split('-')
                      .map(p => moneyShort(p))
                      .join('-')} per month`
                  : 'Any Payment'
              }`
            }
            options={PAYMENT_FILTER_OPTIONS}
            customize={{ fieldType: 'number' }}
          />
        ),
        <StoryFilter group="feature" size="large" />,
        <DropDownFilter
          namespace="q"
          size="large"
          filter="down"
          label={v => {
            return `${!isNull(v) ? moneyShort(v) : 'Any'} down`
          }}
          customize={hasMdrive ? { fieldType: 'number' } : null}
          configKey="downs"
        />,
        <DropDownFilter
          size="large"
          filter="sortBy"
          value={sortBy}
          prefix="Sorted by"
          label={v =>
            `${(hasMdrive ? MDRIVE_SORT_BYS : SORT_BYS)[v] || 'Lowest Payment'}`
          }
          options={Object.keys(hasMdrive ? MDRIVE_SORT_BYS : SORT_BYS)}
        />,
      ]
        .filter(x => x)
        .map(itemMapper('h')),
      featureRow = [
        <StoryFilter group="condition" />,
        <StoryFilter group="year" />,
        <StoryFilter group="make" />,
        <StoryFilter group="model" />,
        <StoryFilter group="trim" />,
      ].map(itemMapper('f')),
      mdriveRow = [
        <DropDownFilter
          allowWilcard={hasMdrive}
          namespace="q"
          filter="leaseTerm"
          label={v => `${v ? `${v} Mo. Lease` : 'Any Lease Term'}`}
          configKey="leaseTerms"
          defaultValue={hasMdrive ? WILDCARD : null}
        />,
        <DropDownFilter
          allowWilcard={hasMdrive}
          namespace="q"
          filter="loanTerm"
          label={v => `${v ? `${v} Mo. Loan` : 'Any Loan Term'}`}
          configKey="loanTerms"
          defaultValue={hasMdrive ? WILDCARD : null}
        />,
        <DropDownFilter
          namespace="q"
          filter="miles"
          label={v => `${v ? numShort(v) : 'Any'} annual miles`}
          configKey="mileages"
        />,
        !hasMdrive && (
          <DropDownFilter
            namespace="q"
            filter="creditScore"
            defaultValue="800"
            label={
              v =>
                `${!isNull(v) ? `${v == '0' ? 800 : v}+` : 'Any'} credit score` //eslint-disable-line
            }
            configKey="creditTiers"
          />
        ),
      ]
        .filter(x => x)
        .map(itemMapper('m'))

    return (
      <div
        className={c('inventory-controls', className, {
          'no-squeeze': noSqueeze,
        })}
      >
        <RawExpando>
          {({ toggle, open }) => (
            <>
              <div className={c('inventory-controls-inner', { open })}>
                <div className="inventory-control-group inventory-story-control-group">
                  <div className="filter-toggler">
                    <Button
                      size="small"
                      success={open}
                      primary={!open}
                      icon={!open ? 'filter' : 'car'}
                      style={{ flex: 1 }}
                      onClick={() => {
                        removeFromPageState('filtersOpen')
                        toggle()
                        window.scrollTo(0, 0)
                      }}
                    >
                      See all {num(trueResultsCount)} Matches
                    </Button>
                  </div>

                  <div className="story-filters-filters hero-filters">
                    {[...heroRow]}
                  </div>

                  <div className="story-filters-filters">
                    {[...featureRow, ...mdriveRow]}
                  </div>

                  <div className="story-filters-controls">
                    <div className="story-filters-count">
                      <p>
                        <span>
                          <Icon
                            fixedWidth
                            spin={isLoading}
                            icon={!isLoading ? 'car' : 'circle-notch'}
                          />{' '}
                          {!isLoading && num(trueResultsCount)}
                        </span>
                      </p>
                    </div>
                    <Button
                      text
                      size="small"
                      icon="question-circle"
                      onClick={this.props.toggleTour}
                    >
                      Help
                    </Button>
                    <Button
                      text
                      size="small"
                      icon="plug"
                      onClick={() =>
                        addToPageState({
                          showInventoryFilters: true,
                        })
                      }
                    >
                      Power Search
                    </Button>
                    <Button
                      text
                      size="small"
                      icon="times-circle"
                      onClick={() => {
                        clearFilters()
                        removeFromPageState('filtersOpen')
                        toggle()
                        window.scrollTo(0, 0)
                      }}
                    >
                      Reset Filters
                    </Button>
                  </div>
                </div>
              </div>
              {!open && (
                <span className={c('filter-toggle', { open })}>
                  <Button
                    size="small"
                    primary
                    icon="filter"
                    onClick={() => {
                      window.scrollTo(0, 0)
                      addToPageState({ filtersOpen: true })
                      toggle()
                    }}
                  >
                    Filter and Sort ({selectedFiltersCount})
                  </Button>

                  <Button
                    white
                    size="small"
                    icon="times-circle"
                    onClick={() => {
                      clearFilters()
                      window.scrollTo(0, 0)
                    }}
                  >
                    See All Cars
                  </Button>
                </span>
              )}
            </>
          )}
        </RawExpando>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let selectedFiltersCount = Object.keys(getSelectedFilters(state) || {}).length

  return {
    ...op,
    selectedFiltersCount,
    hasIds: getVehicleIds(state).length,
    selectedSortBy: getSortBy(state),
    trueResultsCount: getFilteredInventoryCount(state),
    allVehicleCount: getAllVehilceIds(state).length,
    isLoading: isLoading(state),
    hasLeases: inventoryHasLeases(state),
    hasLoans: inventoryHasLoans(state),
    zipCode: getQueryValue(state, 'q.zipCode'),
    sortBy: getParamValue(state, 'inventory.sortBy') || getDefaultSort(state),
    hasMdrive: getHasMdrive(state),
    noSqueeze: getIsLoggedIn(state),
  }
}

export default connect(
  mapStateToProps,
  { addToPageState, clearFilters, setSortBy, removeFromPageState },
)(DashboardControls)
